exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1WA_hHZT2LzanZt1pEqOah{padding:0}._19_cgangmnYbtkLyJ1xsIO{background-color:#f3f5f7}._1rbmB9JB-2H8eeRKMngQZ4{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3KbaxUZkS1S5f7m244Nr-J{cursor:default;-webkit-box-flex:1;-webkit-flex:1 1 0%;-moz-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin:.21429rem 0;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap;font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-size:1.14286rem;font-weight:400;letter-spacing:.07143rem;line-height:1.25}._2JPi_UTNue92TdkwmqBSQI{padding:2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Feedback_content": "_1WA_hHZT2LzanZt1pEqOah",
	"Feedback_content_note": "_19_cgangmnYbtkLyJ1xsIO",
	"Feedback_header": "_1rbmB9JB-2H8eeRKMngQZ4",
	"Feedback_header_title": "_3KbaxUZkS1S5f7m244Nr-J",
	"Feedback_btns": "_2JPi_UTNue92TdkwmqBSQI"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/SessionReport/Feedback/style.postcss
// module id = 1857
// module chunks = 0